
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from "@/integrations/supabase/client";
import { Post } from "@/types/board";
import { cn } from '@/lib/utils';

const LocalNewsSection = () => {
  const [localNews, setLocalNews] = useState<Post[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLocalNews = async () => {
      try {
        const { data, error } = await supabase
          .from('board_posts')
          .select('*')
          .eq('category', '로컬뉴스')
          .order('created_at', { ascending: false })
          .limit(4);
        
        if (error) {
          console.error('Error fetching local news:', error);
          return;
        }
        
        setLocalNews(data as Post[]);
      } catch (error) {
        console.error('Failed to fetch local news:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchLocalNews();
  }, []);

  const formatDate = (date: string) => {
    const now = new Date();
    const postDate = new Date(date);
    const diffInMs = now.getTime() - postDate.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    
    if (diffInHours < 24) {
      if (diffInHours < 1) {
        const minutes = Math.floor(diffInMs / (1000 * 60));
        return `${minutes}분 전`;
      } else {
        const hours = Math.floor(diffInHours);
        return `${hours}시간 전`;
      }
    } else {
      const month = String(postDate.getMonth() + 1).padStart(2, '0');
      const day = String(postDate.getDate()).padStart(2, '0');
      
      return `${month}.${day}`;
    }
  };

  return (
    <div>
      {isLoading ? (
        <div className="space-y-3">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="h-6 bg-muted rounded w-full" />
          ))}
        </div>
      ) : localNews.length > 0 ? (
        <ul className="space-y-2 divide-y divide-gray-100">
          {localNews.map((post) => {
            const dateField = post.created_at || post.createdAt;
            const isRecent = new Date().getTime() - new Date(dateField).getTime() < 24 * 60 * 60 * 1000;
            
            return (
              <li key={post.id} className="pt-2 first:pt-0">
                <Link 
                  to={`/news/${post.id}`} 
                  className="flex justify-between hover:text-primary transition-colors"
                >
                  <div className="flex items-center max-w-[70%]">
                    <span className="line-clamp-1 text-sm">{post.title}</span>
                  </div>
                  <span className={cn(
                    "text-xs shrink-0 whitespace-nowrap",
                    isRecent ? "text-primary" : "text-gray-400"
                  )}>
                    {formatDate(dateField)}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="text-center py-4 text-muted-foreground">
          로컬뉴스가 없습니다
        </div>
      )}
    </div>
  );
};

export default LocalNewsSection;
